<script setup>
defineProps({
  title: {
    type: String,
    default: 'global.all',
    required: true,
  },
  selected: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div
    class="h300 rounded-full border px-6 py-3 flex items-center justify-center whitespace-nowrap"
    :class="{
      'bg-darkOcean-100 border-2 border-darkOcean-600': selected,
      'border-neutral-400': !selected,
    }"
  >
    {{ title }}
  </div>
</template>
